import Swiper from 'swiper';
import { Navigation, Pagination,Autoplay  } from 'swiper/modules';
import { $$ } from '@zimpa/dom';

const ROOT_CLASS = '.js-slider';

export function slider(): void {
    $$(ROOT_CLASS).forEach((container: HTMLElement): void => {

        new Swiper(container, {
            slidesPerView: 'auto',
            spaceBetween: 30,
            centeredSlides: true,
            loop: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false
            },
            loopFillGroupWithBlank: false,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            pagination: {
                clickable: true,
                el: '.swiper-pagination',
                type: 'bullets',
            },
            modules: [
                Navigation,
                Pagination,
                Autoplay
            ]
        });

    });
}
